@if(versionDifference$ | async){
<rask-validation-message-row
    class="mt-2"
    type="warning"
    message="Det finns en nyare version av kontraktsutskrift än som är skickad.">
</rask-validation-message-row>
}

@if(aktivSignering$ | async; as aktivSignering){
<rask-kontrakt-digitalsignering-item
    [signeringInfo]="aktivSignering"
    [readonly]="false">
</rask-kontrakt-digitalsignering-item>
}

<div class="d-flex mt-2">
    @if(inaktivaSigneringar$ | async; as signeringar){
    <div class="history-label">
        <a href="javascript: void(0)" (click)="openHistorik(signeringar)">
            <span>Tidigare signeringar({{signeringar.length}})</span>
            <i class="far fa-external-link fa-sm ms-1"></i>
        </a>
    </div>
    }
    <div class="d-flex flex-column ms-auto">
        <rask-button
            class="send-signing-button"
            color="primary"
            aid="buttonoppnakontraktsignering"
            [disabled]="!canSendContractForSigning() || (sendContractForSigningDisabled$ | async)"
            (click)="openSignering()">
            @if(loading){
            <rask-busy-spinner size="1">
            </rask-busy-spinner>
            }
            <span class="ms-1">Förbered signering</span>
        </rask-button>
        @if(aktivSignering$ | async; as aktivSignering){
        <span class="sent-text">Senast skickad:
            {{aktivSignering.skickatDatum}}
        </span>
        }

    </div>
</div>